import React, { useState } from 'react';
import './index.scss';
import PropTypes from 'prop-types';
import { AiOutlineRight } from 'react-icons/ai';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { formatearFecha } from '../../utils/util';

const cardTurnHours = ({
  fecha, disponible, navigateTo, handleSave, type
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleHover = () => {
    setIsHovered(!isHovered);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    (
      disponible === true ? (

        <div>

          <div
            className={`container-turnHours ${isHovered ? 'container-turnHours--hovered' : ''}`}
            defaultValue="placeholder"
            onMouseEnter={handleHover}
            onMouseLeave={handleHover}
            onClick={() => {
              dispatch(handleSave());
              navigate(navigateTo);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                dispatch(handleSave());
                navigate(navigateTo);
              }
            }}
            role="button"
            tabIndex={0}
          >
            <p placeholder="true">
              {type === 'hour' ? fecha : formatearFecha(fecha)}
            </p>
            <div className="option-red" placeholder="true">
              <AiOutlineRight />
            </div>

          </div>
        </div>
      )
        : (
          <div
            className="disable"
            defaultValue="placeholder"
          >
            <p placeholder="true">
              {type === 'hour' ? fecha : formatearFecha(fecha)}
            </p>
            <div className="option-disabled" placeholder="true">
              <AiOutlineRight />
            </div>

          </div>
        )
    )
  );
};

cardTurnHours.propTypes = {
  fecha: PropTypes.string.isRequired,
  disponible: PropTypes.bool.isRequired,
  navigateTo: PropTypes.string.isRequired,
  handleSave: PropTypes.func.isRequired
};

export default cardTurnHours;
